'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDeviceDesktop = function TiDeviceDesktop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 1.7h-30c-2.8 0-5 2.2-5 5v18.3c0 2.8 2.2 5 5 5h10v3.3h-5c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.7 1.7 1.7h20c0.9 0 1.7-0.8 1.7-1.7s-0.8-1.7-1.7-1.7h-5v-3.3h10c2.8 0 5-2.2 5-5v-18.3c0-2.8-2.2-5-5-5z m-11.7 31.6h-6.6v-3.3h6.6v3.3z m13.4-8.3c0 0.9-0.8 1.7-1.7 1.7h-30c-0.9 0-1.7-0.8-1.7-1.7v-18.3c0-0.9 0.8-1.7 1.7-1.7h30c0.9 0 1.7 0.7 1.7 1.7v18.3z m-3.4-18.3h-26.6c-0.9 0-1.7 0.7-1.7 1.6v13.4c0 0.9 0.8 1.6 1.7 1.6h26.6c1 0 1.7-0.7 1.7-1.6v-13.4c0-0.9-0.7-1.6-1.7-1.6z m0 15h-26.6v-13.4h26.6v13.4z' })
        )
    );
};

exports.default = TiDeviceDesktop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/device-desktop.js
// module id = 3572
// module chunks = 0